import { ArrayInput, Create, SimpleForm, SimpleFormIterator, TextInput } from "react-admin";
import { RichTextInput } from "ra-input-rich-text";




export function MomentCreate() {
    return (
        <Create>
            <SimpleForm>
                <TextInput source="name" />
                <RichTextInput source="description" />
                <ArrayInput source="tags">
                    <SimpleFormIterator>
                        <TextInput source="" />
                    </SimpleFormIterator>
                </ArrayInput>
            </SimpleForm>
        </Create>
    );
}